/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} View_ScoresInputs */

const fr_view_scores = /** @type {(inputs: View_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir les scores`)
};

/**

* @param {View_ScoresInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const view_scores = /** @type {((inputs?: View_ScoresInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<View_ScoresInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_view_scores(inputs)
});